









import { defineComponent, ref } from "@vue/composition-api";
import { InputIuguCreditCard } from "@scrile/api-provider/dist/api/IuguPurchaseProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { PurchaseSubjectTypeEnum } from "@scrile/api-provider/dist/api/PurchaseTypeProvider";
import { RecurringBillingScheduleSubjectTypeEnum } from "@scrile/api-provider/dist/api/RecurringBillingScheduleProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import { useCreditCardAssignment } from "@/hooks/useCreditCardAssignment";
import emitter from "@/lib/emitter";
import { FormValues } from "@/types";
import { EVENTS } from "@/const";
import ModalView from "@/components/ModalView";
import PageTitle from "@/components/PageTitle";
import CardEditView from "../../../components/CardEditView";

export default defineComponent({
  name: "CreditCardType",
  components: { ModalView, CardEditView, PageTitle },
  props: {
    processing: { type: Boolean, required: true },
    paymentSystem: { type: Object as () => PaymentSystemPublic, required: true },
    price: { type: String },
    purchaseSubject: { type: Object as () => Subject<PurchaseSubjectTypeEnum> },
    subscriptionSubject: { type: Object as () => Subject<RecurringBillingScheduleSubjectTypeEnum> },
  },
  setup(props, { emit }) {
    const { getCreditCardsBySystemId } = useCreditCardAssignment();
    const show = ref(false);

    const checkCreditCardAssigned = async () => {
      return !!getCreditCardsBySystemId(props.paymentSystem.id);
    };

    const getName = (nameOnCard: string) => {
      const [firstName, ...lastName] = nameOnCard.split(" ");
      return { firstName, lastName: lastName.join(" ") };
    };

    const onSubmit = async ({
      billingDetails,
      cardDetails,
      saveCard,
    }: {
      cardDetails: FormValues;
      billingDetails: FormValues;
      saveCard: boolean;
    }) => {
      const { cardNumber, expireDate, cvc, nameOnCard } = cardDetails;
      const expMonth = expireDate.split("/")[0];
      const expYear = expireDate.split("/")[1];
      const { country, state, city, address, zip } = billingDetails;
      const { firstName, lastName } = getName(nameOnCard);

      if (!lastName) {
        emitter.emit(EVENTS.STATUS_SHOW, { text: "Name on card should contain at least 2 words" });
        return;
      }
      const data: InputIuguCreditCard = {
        cardNumber,
        expMonth: Number(expMonth),
        expYear: Number((expYear.length === 2 ? "20" : "") + expYear),
        address,
        cvc,
        country,
        state,
        city,
        zip,
        firstName,
        lastName,
        saveCard,
      };

      emit("submit", {
        billingDetails: data,
        type: "creditCard",
        purchaseSubject: props.purchaseSubject,
      });
    };

    checkCreditCardAssigned().then(assigned => {
      if (!assigned) {
        show.value = true;
      } else {
        emit("submit", {
          type: "creditCard",
          purchaseSubject: props.purchaseSubject,
        });
      }
    });
    return {
      show,
      onSubmit,
    };
  },
});
